import { eventsKeys, processableQuestions } from '../constants';
import send from './send';

export default (params = {}) => {
  const { questionId } = params || {};

  if (!questionId || !processableQuestions.includes(questionId)) {
    return;
  }

  send(eventsKeys.CLICK_NEXT_ON_A_QUESTION, {
    questionId,
  });
};
